import { Adtrgtng } from './interfaces'
import Cookies from 'js-cookie';
import { getBrandDomain } from './domain'

export const TARGETING_COOKIE_NAME = 'upptrgtng'
export const TARGETING_COOKIE_TTL_HOURS = 1

export function getTargetingData(): Adtrgtng | null {
  const cookieValue = Cookies.get(TARGETING_COOKIE_NAME)
  if (!cookieValue) {
    return null
  }

  try {
    return JSON.parse(atob(cookieValue))
  } catch (e) {
    console.error('Error parsing targeting cookie:', e)
    return null
  }
}

export function setTargetingData(data: Adtrgtng, cookieTtlHours = TARGETING_COOKIE_TTL_HOURS) {
  const encodedData = btoa(JSON.stringify(data))
  const expires = new Date()
  expires.setHours(expires.getHours() + cookieTtlHours)
  Cookies.set(TARGETING_COOKIE_NAME, encodedData, {
    path: '/',
    sameSite: 'None',
    secure: true,
    domain: getBrandDomain(),
    expires,
  })
}
